// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * OPC UA DateTime: 100-nanosecond intervals since 1601-01-01 00:00:00 UTC.
 */
export class DateTime implements flatbuffers.IUnpackableObject<DateTimeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DateTime {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDateTime(bb: flatbuffers.ByteBuffer, obj?: DateTime): DateTime {
    return (obj || new DateTime()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDateTime(bb: flatbuffers.ByteBuffer, obj?: DateTime): DateTime {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DateTime()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startDateTime(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(0, value, 0n);
  }

  static endDateTime(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createDateTime(builder: flatbuffers.Builder, value: bigint): flatbuffers.Offset {
    DateTime.startDateTime(builder);
    DateTime.addValue(builder, value);
    return DateTime.endDateTime(builder);
  }

  unpack(): DateTimeT {
    return new DateTimeT(this.value());
  }

  unpackTo(_o: DateTimeT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): DateTimeT {
    const t = new DateTimeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class DateTimeT implements flatbuffers.IGeneratedObject {
  constructor(public value: bigint = 0n) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return DateTime.createDateTime(builder, this.value);
  }

  clone(): DateTimeT {
    const obj = new DateTimeT();
    obj.value = this.value;
    return obj;
  }

  equals(other: DateTimeT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyDateTime(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
